angular.module('dpw.directives').directive('dpwAppProfileListRow', [function () {
    return {
        restrict: 'A',
        scope: {
            appProfile: '<',
            onDelete: '&?'
        },
        bindToController: true,
        controllerAs: '$ctrl',
        templateUrl: 'dpw-app-profile-list-row.html',
        controller: ['dpwRoutes', 'appProfileUtils', 'popupUtil', 'api', function (dpwRoutes, appProfileUtils, popupUtil, api) {
            var self = this;
            if (!!self.appProfile.appProfileAndRevisionViewId) {
                self.appProfile.id = self.appProfile.appProfileAndRevisionViewId.appProfileId;
                self.appProfile.brand = self.appProfile.brandId;
            }

            self.hasLinkedApp = function () {
                return appProfileUtils.hasLinkedApp(self.appProfile);
            };
            self.isRevision = function () {
                return _.get(self.appProfile, 'appProfileAndRevisionViewId.type') === 'revision';
            };
            self.getAppProfileUrl = function () {
                return appProfileUtils.getAppProfileDetailUrl(self.appProfile.applicationId);
            };
            self.onEditProfile = function () {
                appProfileUtils.onEditProfile();
            };

            self.getColorClassByProfileStatus = function (status) {
                return appProfileUtils.getColorClassByProfileStatus(status);
            };

            self.getLinkedAppUrl = function () {
                if (RCDPW.isAdminSite) {
                    var appDetailPath = dpwRoutes.app.path.replace(':id', self.appProfile.applicationId);
                    return [location.pathname, appDetailPath].join('#');
                } else {
                    var appDashboardPath = dpwRoutes.appDashboard.path.replace(':id', self.appProfile.applicationId);
                    return [location.pathname, appDashboardPath].join('#');
                }
            };

            self.canDelete = function () {
                if (!self.isRevision()) {
                    return appProfileUtils.isInitialized(self.appProfile.status) ||
                        appProfileUtils.isDeclined(self.appProfile.status);
                }
            };

            self.delete = function () {
                var requestDelete = function () {
                    api.call(api.admin.appGallery.delete(self.appProfile.id),
                        function () {
                            var scrollTop = $(window).scrollTop();
                            var callback = function () {
                                setTimeout(function () {
                                    window.scrollTo(0, scrollTop);
                                });
                            };
                            if (_.isFunction(self.onDelete)) {
                                self.onDelete({
                                    options: {
                                        callback: callback
                                    }
                                });
                            }
                        }
                    );
                };

                popupUtil.confirm({
                    title: 'Delete profile',
                    content: 'Are you sure you want to delete the profile?',
                    buttons: [
                        {label: 'No', style: 'button-with-border', action: 'close'},
                        {label: 'Yes', style: 'button-orange', action: requestDelete}
                    ]
                });
            };
        }]
    };
}]);
